import React from 'react'

export const Home = () => (
  <div>
    <h1>Home</h1>
  </div>
)
